// extracted by mini-css-extract-plugin
module.exports = {"block":"loadmorebtn_block__uKkTz container","btn":"loadmorebtn_btn__JeRHE"};